/* eslint-disable camelcase */
/* eslint-disable no-alert */
require('es6-promise').polyfill();
const originalFetch = require('isomorphic-fetch');
const fetch = require('fetch-retry')(originalFetch, { retries: 2, retryDelay: 500 });

import { checkStatus, buildUrlWithVersion, DIAGNOSE_DASHBOARD_BASEURL } from '../helper.js';


const GET_NOTIFICATIONS = `${DIAGNOSE_DASHBOARD_BASEURL}/notification/get/`;
const UPDATE_NOTIFICATIONS = `${DIAGNOSE_DASHBOARD_BASEURL}/notification/read/`;
const GET_NOTIFICATIONS_EMAIL_PREFERENCES = `${DIAGNOSE_DASHBOARD_BASEURL}/notification/preferences/users/`;
const CREATE_NOTIFICATIONS_EMAIL_PREFERENCES = `${DIAGNOSE_DASHBOARD_BASEURL}/notification/preferences/users/`
const GET_NOTIFICATIONS_PREFERENCES_WEBSITE = `${DIAGNOSE_DASHBOARD_BASEURL}/notification/preferences/users/websites/`

// TODO: put under permissions service
export function getNotificationsData({ page = 1, metric = '', type = '', isSeen = '', pageSize, dateFrom, dateTo, ...rest }) {
    return fetch(
      buildUrlWithVersion(
        GET_NOTIFICATIONS,
        {
          ...(type ? { type } : {}),
          ...(metric ? { metric } : {}),
          ...(page ? { page } : {}),
          ...(dateFrom ? { date_from: dateFrom } : {}),
          ...(dateTo ? { date_to: dateTo } : {}),
          ...(typeof isSeen === "boolean" ? { is_seen: isSeen } : {}),
          page_size: pageSize,
          ...rest,
        },
        "notifications"
      ),
      {
        credentials: "include",
        mode: "cors",
        headers: {},
      }
    )
      .then(checkStatus)
      .then((resp) => resp.json())
      .catch((err) => {
        console.log(err);
        alert(
          err.response
            ? `Error on get 'Alerts' data: status ${err.response.status}`
            : err
        );
      });
}

export function getPreferencesWebsite({accountId = ''}){
    return fetch(
        buildUrlWithVersion(
            GET_NOTIFICATIONS_PREFERENCES_WEBSITE, 
            {
                accountId,
            },
            'notifications',
        ),
        {
            credentials: 'include',
            mode: 'cors',
            headers: {},
        }
    )
    .then(checkStatus)
    .then((resp) => resp.json())
    .catch((err) => {
        console.log(err);
        alert(err.response ? `Error on get 'Property' data: status ${err.response.status}` : err);
    });
}

export function markNotificationsRead(
  { ids, read_all },
  { metric = "", type = "", isSeen = "", dateFrom, dateTo, accountId }
) {
  return fetch(
    buildUrlWithVersion(
      UPDATE_NOTIFICATIONS,
      {
        accountId,
        ...(type ? { type } : {}),
        ...(metric ? { metric } : {}),
        ...(dateFrom ? { date_from: dateFrom } : {}),
        ...(dateTo ? { date_to: dateTo } : {}),
        ...(typeof isSeen === "boolean" ? { is_seen: isSeen } : {}),
      },
      "notifications"
    ),
    {
      method: "POST",
      credentials: "include",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ids, read_all }),
    }
  )
    .then(checkStatus)
    .then((resp) => resp.json())
    .catch((err) => {
      console.log(err);
      alert(
        err.response
          ? `Error on update 'Alerts' data: status ${err.response.status}`
          : err
      );
    });
}

export function getNotificationEmailPreferences({ email = '', accountId = '', page = 1, limit = 150}) {
    return fetch(
        buildUrlWithVersion(
            GET_NOTIFICATIONS_EMAIL_PREFERENCES,
            {
                email,
                accountId,
                page,
                limit
            },
            'notifications',
        ),
        {
            credentials: 'include',
            mode: 'cors',
            headers: {},
        },
    )
    .then(checkStatus)
    .then((resp) => resp.json())
    .catch((err) => {
        console.log(err);
    });
}


export function createNotificationEmailPreferences(users, accountId) {
    return fetch(
        buildUrlWithVersion(
            CREATE_NOTIFICATIONS_EMAIL_PREFERENCES,
            {},
            'notifications',
        ),
        {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                users,
                accountId,
            }),
        },
    )
    .then(checkStatus)
    .then((resp) => resp.json())
    .catch((err) => {
        console.log(err);
        alert(err.response ? `Error on create 'Alerts Email Preferences' data: status ${err.response.status}` : err);
    });
}



export default null;
